// extracted by mini-css-extract-plugin
export default {"legendContainer":"Legend_legendContainer__vEMgR","legendItem":"Legend_legendItem__2nqs9","dot":"Legend_dot__wWv9I"};